import { Component, Input, OnInit, OnChanges, ChangeDetectorRef } from '@angular/core';

import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DataService, CalculationService } from 'app/services';
import { config, tirePositionOptions, seasonalityOptions, messages } from 'app/constants';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { find, debounce, trim, isEqual } from 'lodash';

@Component({
  selector: 'app-create-tire-storage',
  templateUrl: './create-tire-storage.component.html',
  styleUrls: ['./create-tire-storage.component.scss'],
})
export class CreateTireStorageModal implements OnInit, OnChanges {
  @Input() categories: any[] = [];
  @Input() suppliers: any[] = [];
  @Input() rimTypes: any[] = [];
  @Input() locations: any[] = [];
  @Input() qboItemRefs: any[] = [];
  @Input() pricings: any[] = [];
  @Input() isLoading: boolean = false; // don't set this key inside this component
  @Input() data: any = {};
  @Input() item: any = {};
  @Input() stock: any = {};
  @Input() tireId: string = '';
  @Input() isLocal: boolean = true;
  @Input() isQboConnected: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() isInventoryEnabled: boolean = false;
  @Input() orderServiceItemIndex: number = -1;
  @Input() orderServiceId: string = '';
  @Input() tireType: string = '';
  @Input() serviceItem: any = {};
  @Input() averageCost: number = 0;
  @Input() isAutoLeapItem: boolean = false;
  @Input() defaultTaxable: boolean = false;
  @Input() isTaxable: boolean = false;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() openFrom: string = '';
  @Input() isEnhancedTSEnabled: boolean = false;
  @Input() isFinalizedRo: boolean = false;
  @Input() estimateOrderStatus: string = '';
  @Input() isGlobalCategoryEnabled: boolean = false;
  @Input() isNewItemCategoriesEnable: boolean = false;
  @Input() isSalesCodeEnabled: boolean = false;
  @Input() canEditClassifications: boolean = false;

  tireStorageDisabledTooltip: string = '';
  isPrintingLabel: boolean = false;
  isTireStorageUpdated: boolean = false;
  //isDeepCopy:boolean = true
  defaultSizeObject = {
    size: '',
    code: '',
    cost: '',
    pricingMatrix: null,
    price: '',
    isTaxable: true,
    status: true,
    displayDescOnOrder: true,
    displayHoursOnOrder: true,
  };
  defaultTireInfo: any = {
    tireLabel: '',
    rimType: '',
    treadDepth: '',
    recommendReplacement: false,
    storageLocation: '',
  };
  tire: any = {
    brand: null,
    model: '',
    vendor: null,
    seasonality: '',
    stocked: '',
    sizes: [this.defaultSizeObject],
    tiresInfo: [],
    errors: [],
  };
  defaultTireData: any = {
    brand: null,
    model: '',
    vendor: null,
    seasonality: '',
    stocked: '',
    sizes: [this.defaultSizeObject],
    tiresInfo: [],
    errors: [],
  };
  defaultActiveState: boolean = true;
  tagsSuggestion: any[] = [];
  vendorsSuggestion: any[] = [];
  isProcessing: boolean = false;
  errors: any = {};
  defaultQboItemRefs: any[] = [];
  focus: any = {};
  disabledDuplicate: boolean = false;
  tirePositionOptions: any[] = tirePositionOptions;
  seasonalityOption: any[] = seasonalityOptions;
  isNewCategoriesEnabled: boolean = false;
  categoriesSuggestions: any[] = [];
  subCategoriesSuggestions: any[] = [];
  subSubCategoriesSuggestions: any[] = [];
  isLockedRO = false;
  categoriesSuggestionsResults: any[] = [];
  subCategoriesSuggestionsResults: any[] = [];
  subSubCategoriesSuggestionsResults: any[] = [];
  loader = {
    category: false,
    subCategory: false,
    subSubCategory: false,
  };
  classificationPrivilegeMsg: string = messages.classificationPrivilegeMsg;
  defaultSalesCode: any = {};
  isAutoAssign: boolean = false;
  defaultTireCategory: any = null;

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private dialogService: DialogService,
    private calculationService: CalculationService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (this.openFrom === 'RO') {
      this.isLockedRO = this.dataService.isLockedRO;
    }
    this.getAllCategories();
  }

  ngOnChanges(change: any) {
    const { isLoading } = change;
    this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
    if (isLoading) {
      if (isLoading.previousValue && !isLoading.currentValue) {
        this.setCategories(this.categories);
        this.setSuppliers(this.suppliers);
        this.setItemDetails(this.item);

        if (!this.tireId && this.tire.sizes && this.tire.sizes[0]) {
          this.tire.sizes[0].isTaxable = this.isTaxable;
        }
      }
    }
  }

  initializePricings() {
    if (!this.tireId) {
      this.setTireData();
    }
  }

  setCategories(categories: any[]) {
    this.tagsSuggestion = [...categories];
    this.cdr.detectChanges();
  }

  setSuppliers(suppliers: any[]) {
    this.vendorsSuggestion = [...suppliers];
  }

  setItemDetails(tire: any) {
    if (!this.tireId || !tire) {
      this.tire.sizes[0].commissionable = this.dataService.isCommissionTireStorage;
      if (this.isEnhancedTSEnabled) {
        this.handleAddTireInfo(this.defaultTireInfo);
      }
      return;
    }

    this.tire = {
      errors: [],
      model: tire.model,
      seasonality: tire.seasonality,
      stocked: tire.stocked,
      externalId: tire.externalId,
      salesCode: tire.salesCode,
      isInStorage: tire.isInStorage,
      isReturned: tire.isReturned,
      category: tire.category,
      tiresInfo: [],
      sizes: [
        {
          isTaxable: tire.isTaxable,
          status: tire.status,
          size: tire.size,
          stocked: tire.stocked,
          count: Number(tire.count),
          title: tire.title,
          tireID: this.tireId,
          code: tire.code,
          restockLevel: tire.restockLevel || null,
          cost: Number(tire.cost),
          price: Number(tire.price),
          description: tire.description || null,
          descriptionFR: tire.descriptionFR || null,
          notes: tire.notes || null,
          totalCost: Number(tire.cost) * Number(tire.count),
          totalPrice: Number(tire.price) * Number(tire.count),
          displayDescOnOrder: tire.displayDescOnOrder,
          displayHoursOnOrder: tire.displayHoursOnOrder,
          internalNotes: tire.notes || null,
        },
      ],
    };

    if (this.isNewCategoriesEnabled) {
      if (!this.tire.category?._id && this.defaultTireCategory?._id) {
        this.tire.category = this.defaultTireCategory;

        if (this.defaultTireCategory.salesCode?.salesCodeId) {
          this.tire.salesCode = this.defaultTireCategory.salesCode;
        }
      }
    }

    if (this.isEnhancedTSEnabled) {
      this.tire.title = tire.title;
    }

    if (tire.qboId) {
      this.tire.qboId = tire.qboId;
    }

    if (tire.isInStorage) {
      this.tireStorageDisabledTooltip = `Already ${tire.isReturned ? 'returned' : 'stored'} tires can not be edited`;
    }

    if (tire.tiresInfo && tire.tiresInfo.length) {
      if (this.isEnhancedTSEnabled) {
        this.disabledDuplicate = tire.tiresInfo.length >= 6;
      }

      tire.tiresInfo.forEach((tireInfo: any) => {
        const previousTire = {
          previousStorageLocation: tireInfo?.storageLocation?.name || '',
          tireLabel: tireInfo?.tireLabel,
          treadDepth: tireInfo?.treadDepth,
          oldTreadDepth: '',
          recommendReplacement: tireInfo?.recommendReplacement,
          rimType: find(this.rimTypes, { name: tireInfo.rimType }),
          storageLocation: find(this.locations, { locationId: tireInfo?.storageLocation && tireInfo?.storageLocation.locationId }),
          brand: { _id: tireInfo?.brand?.brandId, name: tireInfo?.brand?.name },
          seasonality: find(this.seasonalityOption, { value: tireInfo?.seasonality || tire?.seasonality }),
          model: tireInfo?.model || tire?.model,
          size: tireInfo?.size || tire?.size,
          tirePosition: find(this.tirePositionOptions, { value: tireInfo?.tirePosition }),
          partNumber: tireInfo?.partNumber || tire?.code,
        };

        if (this.isEnhancedTSEnabled) {
          const { isValid } = this.helperService.getTreadDepth(previousTire.treadDepth);

          if (!isValid) {
            previousTire.oldTreadDepth = previousTire.treadDepth;
          }
        }

        if (previousTire.brand && !previousTire.brand?.name && tire?.category?.categoryId) {
          previousTire.brand = { name: tire?.category?.name, _id: tire?.category?.categoryId };
        }

        this.tire.tiresInfo.push(previousTire);
      });
    }

    if (tire.category && tire.category.categoryId) {
      this.tire.brand = {
        _id: tire.category.categoryId,
        name: tire.category.name,
      };
    } else {
      this.tire.brand = {
        name: tire.brand,
      };
    }

    if (tire.supplier && tire.supplier.name) {
      this.tire.vendor = {
        _id: tire.supplier.supplierId,
        name: tire.supplier.name,
      };
    }

    if (tire.pricing && tire.pricing.pricingId) {
      this.tire.sizes[0].pricingMatrix = {
        _id: tire.pricing.pricingId._id,
        name: tire.pricing.pricingId.name,
      };
    }

    if (this.isSalesCodeEnabled) {
      this.defaultSalesCode = this.helperService.deepCopy(tire?.salesCode);
    }

    this.setSelectPricing();
    this.setItemRef();
    this.setTireData();
    this.isProcessing = false;
    this.defaultTireData = this.helperService.deepCopy(this.tire);
  }

  displaySalesCodeTitle() {
    return this.helperService.displaySalesCodeTitle(this.tire.salesCode, this.tire.category);
  }

  openAssignSalesCodeDialog() {
    if (!this.canEditClassifications && this.openFrom !== 'RO') {
      return;
    }
    const data = {
      item: this.tire,
      openFrom: 'tireStorage-modal',
    };
    data.item.title = data.item?.title || '';
    this.dataService.sendData(this.dataService.typeDialog('open-sales-code-assign-modal', 'tireStorage-modal', null, null, data));
  }

  setTireData(isMappingNeeded: boolean = false) {
    if (this.serviceItem && this.serviceItem.itemId) {
      if (this.serviceItem.model) {
        this.tire.model = this.serviceItem.model;
      }

      const size = {
        ...this.tire.sizes[0],
        description: this.serviceItem.description,
        notes: this.serviceItem.notes,
      };

      if (this.serviceItem.hasOwnProperty('seasonality')) {
        this.tire.seasonality = this.serviceItem.seasonality;
      }

      if (this.serviceItem.title) {
        this.tire.title = this.serviceItem.title;
      }

      if (this.serviceItem.titleFR) {
        this.tire.title = this.serviceItem.titleFR;
      }

      if (this.serviceItem.hasOwnProperty('salesCode') && this.serviceItem.salesCode?.salesCodeId) {
        this.tire.salesCode = this.serviceItem.salesCode;
      }

      if (this.serviceItem.category && this.serviceItem.category.name) {
        const { categoryId, name } = this.serviceItem.category;
        this.tire.brand = { name };

        if (categoryId) this.tire.brand._id = categoryId;
      }

      if (this.serviceItem.supplier && this.serviceItem.supplier.name) {
        const { supplierId, name } = this.serviceItem.supplier;
        this.tire.vendor = { name };

        if (supplierId) this.tire.vendor._id = supplierId;
      }

      if (this.serviceItem.hasOwnProperty('price')) {
        size.price = this.serviceItem.price;
      }

      if (this.serviceItem.hasOwnProperty('cost')) {
        size.cost = this.serviceItem.cost;
      }

      if (this.serviceItem.hasOwnProperty('isTaxable')) {
        size.isTaxable = this.serviceItem.isTaxable;
      }

      if (this.serviceItem.hasOwnProperty('commissionable')) {
        size.commissionable = this.serviceItem.commissionable;
      }

      if (this.serviceItem.hasOwnProperty('displayDescOnOrder')) {
        size.displayDescOnOrder = this.serviceItem.displayDescOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('displayHoursOnOrder')) {
        size.displayHoursOnOrder = this.serviceItem.displayHoursOnOrder;
      }

      if (this.serviceItem.code) {
        size.code = this.serviceItem.code;
      }

      if (this.serviceItem.size) {
        size.size = this.serviceItem.size;
      }

      if (this.serviceItem.hasOwnProperty('count')) {
        size.count = this.serviceItem.count;
      }

      if (this.serviceItem.pricing && this.serviceItem.pricing.pricingId) {
        size.pricingMatrix = this.serviceItem.pricing;
      }

      if (this.serviceItem.pricing && this.serviceItem.pricing.pricingId) {
        size.pricingMatrix = {
          _id: this.serviceItem.pricing.pricingId,
          name: this.serviceItem.pricing.name,
        };
      }

      if (!isNaN(size.price) && !isNaN(size.cost) && !isNaN(size.count)) {
        size.totalPrice = this.calculationService.roundOff(Number(size.price * size.count));
        size.totalCost = this.calculationService.roundOff(Number(size.cost * size.count));
      }

      this.tire.sizes = [size];

      if (this.serviceItem.qboId) {
        this.tire.qboId = this.serviceItem.qboId;
        this.setItemRef();
      }

      if (isMappingNeeded) {
        this.setSelectPricing();
      }
    }
  }

  /** Fetching items reference from QBO */
  fetchItemRefs() {
    this.httpService.getQBOItemRefs().then(
      (data: any) => {
        if (data.items && data.items.length) {
          this.qboItemRefs = data.items.filter(({ type }) => type === 'part');
          this.setItemRef();
          this.defaultQboItemRefs = this.helperService.deepCopy(this.qboItemRefs);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  setSelectPricing() {
    if (this.tire.sizes && this.tire.sizes[0].pricingMatrix && this.pricings && this.pricings.length) {
      const [pricing] = this.pricings.filter(({ _id }) => _id === this.tire.sizes[0].pricingMatrix._id);

      if (pricing) {
        this.tire.sizes[0].pricingMatrix = pricing;
      }
    }
  }

  getCompanyDetails() {
    return new Promise((resolve, reject) => {
      const { companyId } = this.helperService.getCompany();

      this.httpService.getCompanyDetails(companyId).then(
        (company) => {
          if (company && company.shop) {
            // this.isTaxable = company.shop.tire;
            // this.defaultSizeObject.isTaxable = this.isTaxable;
          }

          resolve({});
        },
        (err) => {
          reject(err);
          this.helperService.showToaster('error', err);
        }
      );
    });
  }

  /** Fetch list of all the tags */
  getTagList() {
    this.httpService.getTags(config.tags.tire).then(
      (categories: any[]) => {
        if (categories && categories.length) {
          this.categories = [...categories];
          this.tagsSuggestion = [...this.categories];
          this.cdr.detectChanges();
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleTagSearch(query: string) {
    if (!query) {
      return;
    }

    this.tagsSuggestion = this.categories.filter(({ name }) => new RegExp(query, 'i').test(name));
  }

  onSearchItem(name: string, query: string) {
    if (name === 'category') {
      this.categoriesSuggestionsResults = this.categoriesSuggestions.filter(({ categoryName }) => categoryName && new RegExp(`${query}`, 'gi').test(categoryName));
    } else if (name === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.subCategoriesSuggestions.filter(({ subCategoryName }) => subCategoryName && new RegExp(`${query}`, 'gi').test(subCategoryName));
    } else if (name === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.subSubCategoriesSuggestions.filter(({ subSubCategoryName }) => subSubCategoryName && new RegExp(`${query}`, 'gi').test(subSubCategoryName));
    }
  }

  handleVendorSearch(query: string) {
    if (!query) {
      return;
    }

    this.vendorsSuggestion = this.suppliers.filter(({ name }) => new RegExp(query, 'i').test(name));
  }

  handleClear(type: string) {
    if (type === 'vendor') {
      this.vendorsSuggestion = [...this.suppliers];
    } else if (type === 'category') {
      this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
    } else if (type === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
    } else if (type === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestionsResults);
    } else {
      this.tagsSuggestion = [...this.categories];
    }
  }

  handleSelect(data: any, type: string) {
    if (type === 'brand') {
      this.tire.brand = data;
      this.errors.brand = '';
      this.tire = this.helperService.deepCopy(this.tire);
    } else {
      this.tire.vendor = data;
    }
  }

  handleChange(value: string, type: string) {
    // unselect seasonlity
    if (type === 'seasonality') {
      if (value === this.tire.seasonality) {
        value = '';
      }
    }
    if (type === 'stocked') {
      this.tire.sizes[0].stocked = value;
    }

    this.tire[type] = value;
    this.errors[type] = '';
  }

  handleBlur(type: string) {
    if (type === 'model') {
      this.tire = this.helperService.deepCopy(this.tire);
    }
  }

  handleFocus(type: string) {
    this.errors[type] = '';
    this.focus[type] = true;

    if (type === 'subCategory' && !this.subCategoriesSuggestionsResults?.length) {
      if (this.tire.category?.categoryId) this.getSubCategories(this.tire.category);
    }

    if (type === 'subSubCategory' && !this.subSubCategoriesSuggestionsResults?.length) {
      if (this.tire.category?.categoryId && this.tire.category?.subCategoryId) this.getSubSubCategories(this.tire.category, this.tire.category);
    }
  }

  handleAddSize() {
    this.tire.sizes.push(this.helperService.deepCopy(this.defaultSizeObject));
  }

  handleAddTireInfo(data?: any) {
    if (this.isEnhancedTSEnabled && data) {
      const dataObj: any = this.helperService.deepCopy(data);
      dataObj.activeIndex = 0;
      dataObj.isManuallyAdded = true;
      this.tire.tiresInfo.push(this.helperService.deepCopy(dataObj));
    } else {
      this.tire.tiresInfo.push(this.helperService.deepCopy(this.defaultTireInfo));
    }
    this.disabledDuplicate = this.tire.tiresInfo.length >= 6;
  }

  handleDeleteTireSize(index: number) {
    this.tire.sizes.splice(Number(index), 1);
    this.tire.errors[index] = {};
  }

  handleDeleteStorageTire(index: number) {
    this.tire.tiresInfo.splice(Number(index), 1);
    this.disabledDuplicate = this.tire.tiresInfo.length >= 6;
    // this.tire.errors[index] = {};
  }

  handleCloseModal() {
    this.dynamicDialogRef.close();
  }

  handleTirestoragePrint() {
    let hasUnsavedChanges: boolean = false;
    // if(this.isDeepCopy) {
    //   //this.defaultTireData = this.helperService.deepCopy(this.tire.tiresInfo)
    //   this.isDeepCopy = false
    // }

    if (this.tire.tiresInfo && this.defaultTireData.tiresInfo && this.tire.tiresInfo.length === this.defaultTireData.tiresInfo.length) {
      for (let i = 0; i < this.tire.tiresInfo.length; i++) {
        const defaultInfo = this.defaultTireData.tiresInfo[i];
        const tireDataInfo = this.tire.tiresInfo[i];
        tireDataInfo.brand._id = tireDataInfo.brand._id || tireDataInfo.brand.brandId;
        if (
          defaultInfo?.brand?._id !== tireDataInfo?.brand?._id ||
          defaultInfo.model !== tireDataInfo.model ||
          defaultInfo.size !== tireDataInfo.size ||
          defaultInfo?.seasonality?.value !== tireDataInfo?.seasonality?.value ||
          defaultInfo.partNumber !== tireDataInfo.partNumber ||
          defaultInfo?.tirePosition?.value !== tireDataInfo?.tirePosition?.value ||
          defaultInfo.treadDepth !== tireDataInfo.treadDepth ||
          defaultInfo?.storageLocation?.locationId !== tireDataInfo?.storageLocation?.locationId ||
          defaultInfo?.rimType?.name !== tireDataInfo?.rimType?.name ||
          defaultInfo.tireLabel !== tireDataInfo.tireLabel ||
          defaultInfo.recommendReplacement !== tireDataInfo.recommendReplacement
        ) {
          hasUnsavedChanges = true;
          break;
        }
      }
    }
    //const hasUnsavedChanges = isEqual(this.tire.tiresInfo,this.defaultTireData.tiresInfo);

    if (hasUnsavedChanges) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          title: 'Save changes?',
          message: 'You have unsaved changes in tire storage. Click save to update changes and print',
          type: 'changes',
          button: {
            success: { title: 'Save' },
            discard: { title: 'Dismiss' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess) {
          this.handleSubmit();
          this.printTireLabel();
        }
        onClose.unsubscribe();
      });
    } else {
      this.printTireLabel();
    }
  }

  printTireLabel() {
    if (this.isPrintingLabel) {
      return;
    }
    this.isPrintingLabel = true;
    this.httpService
      .downloadTireStoragePdf({ orderId: this.item.storageRO && this.item.storageRO.orderId, tireStorageId: this.tireId })
      .then(
        (url) => {
          window.open(url, '_blank');
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isPrintingLabel = false;
      });
  }

  handleValidation() {
    let isValid = true;

    if (!this.tire.brand) {
      this.errors.brand = 'Brand required';
      isValid = false;
    }

    if (!this.tire.model) {
      this.errors.model = 'Vendor required';
      isValid = false;
    }

    if (this.isEnhancedTSEnabled) {
      isValid = true;

      if (!trim(this.tire.title)) {
        this.errors.title = 'Title required';
        this.tire.title = '';
        isValid = false;
      }

      if (this.tire.tiresInfo && this.tire.tiresInfo.length) {
        this.tire.tiresInfo.forEach((tire: any) => {
          tire.activeIndex = null;
          this.cdr.detectChanges();

          if (!trim(tire.brand)) {
            if (!tire.errors) {
              tire.errors = {};
            }

            tire.errors.brand = 'Brand required';
            tire.brand = '';
            isValid = false;
          }

          if (!trim(tire.model)) {
            if (!tire.errors) {
              tire.errors = {};
            }

            tire.errors.model = 'Vendor required';
            tire.model = '';
            isValid = false;
          }

          if (!trim(tire.size)) {
            if (!tire.errors) {
              tire.errors = {};
            }

            tire.errors.size = 'Size required';
            tire.size = '';
            isValid = false;
          }
      
          if (tire?.treadDepth) {
            const treadDepthParts = tire.treadDepth.split('/');
            const treadNumber = Number(treadDepthParts[0]);
          
            if (!isNaN(treadNumber)) {
              if (treadNumber < 1 || treadNumber > 32) {
                tire.errors = {
                  ...tire.errors,
                  treadDepth: 'Must be between 1 to 32',
                };
                isValid = false;
              }
            } 
          }

          if (!isValid) {
            tire.activeIndex = 0;
          }
        });

        // Always should be at the very end of this code
        if (this.tire.tiresInfo.length > 6) {
          isValid = false;
          this.helperService.showToaster('error', 'Tire storage information cannot be greater than 6 tires.');
        }
      } else {
        isValid = false;
        this.helperService.showToaster('error', 'Please add tire in tire storage information');
      }
    } else {
      this.tire.sizes.forEach(({ size, title }: any, index: number) => {
        if (this.tire.errors[index] && this.tire.errors[index].title) {
          this.tire.errors[index] = {
            title: this.tire.errors[index].title,
          };
        } else {
          this.tire.errors[index] = {};
        }

        if (!size) {
          this.tire.errors[index].size = 'Size required';
          isValid = false;
        }
        if (!title) {
          this.tire.errors[index].title = 'Title required';
          isValid = false;
        }
      });
    }
    return isValid;
  }

  /** Set Item Ref */
  setItemRef() {
    if (this.tire && this.tire.qboId && this.qboItemRefs.length) {
      if (this.tire.sizes[0]) {
        this.tire.sizes[0].qboItemRef = find(this.qboItemRefs, {
          qboId: this.tire.qboId,
        });
      }
    }
  }

  getUpdatedTireInfoLogs() {
    this.tire.tiresInfo.forEach((tire: any, index: number) => {
      if (this.item && this.item.storageRO) {
        tire.orderId = this.item.storageRO && this.item.storageRO.orderId;
        tire.code = this.item.storageRO && this.item.storageRO.code;
      }
      tire.tireState = `Tire ${index + 1}`;
      tire.openFrom = this.openFrom;
      if (tire.storageLocation) {
        if (tire.storageLocation.name !== tire.previousStorageLocation) {
          tire.isUpdated = true;
          tire.storageLocation.previousName = tire.previousStorageLocation;
        }
      }
    });
  }

  handleSubmit() {
    if (!this.handleValidation() || this.isProcessing) {
      return;
    }
    this.getUpdatedTireInfoLogs();
    const [size] = this.tire.sizes;
    const tire: any = {
      cost: Number(size.cost),
      price: Number(size.price),
      code: size.code,
      title: this.isEnhancedTSEnabled ? this.tire.title : size.title,
      model: this.tire.model,
      size: size.size,
      type: 'tireStorage',
      count: 0,
      description: size.description,
      descriptionFR: size.descriptionFR,
      notes: size.notes || size.internalNotes,
      isTaxable: size.isTaxable,
      status: size.status,
      seasonality: this.tire.seasonality,
      displayDescOnOrder: size.displayDescOnOrder,
      displayHoursOnOrder: size.displayHoursOnOrder,
      commissionable: size.commissionable,
    };
    if (this.tire.tiresInfo && this.tire.tiresInfo.length) {
      tire.count = this.tire.tiresInfo.length;
      tire.tiresInfo = this.tire.tiresInfo.map((info: any) => {
        const tire = {
          ...info,
          rimType: info.rimType && info.rimType.name,
          storageLocation: info.storageLocation || null,
          tirePosition: info?.tirePosition?.value || '',
          seasonality: info?.seasonality?.value || '',
          brand: { brandId: info?.brand?._id || info?.brand?.brandId, name: info?.brand?.name },
        };

        return tire;
      });
    }

    if (this.isNewCategoriesEnabled && this.isSalesCodeEnabled) {
      if (this.tire.salesCode && this.tire.salesCode?.salesCodeId) tire.salesCode = this.tire.salesCode;
      else tire.salesCode = {};
    }

    if (this.data.customer) {
      tire.customer = this.data.customer;
    }

    if (this.data.vehicle) {
      tire.vehicle = this.data.vehicle;
    }

    if (!this.tireId) {
      if (this.data.order) {
        tire.storageRO = this.data.order;
      }
    }

    if (size.qboItemRef && size.qboItemRef.qboId) {
      tire.qboItemRefId = size.qboItemRef.qboId;
      tire.qboId = size.qboItemRef.qboId;
    }

    if (this.tire.brand) {
      tire.brand = this.tire.brand.name;
      tire.category = {
        categoryId: this.tire.brand._id,
        name: this.tire.brand.name,
      };
    }

    if (this.tire.vendor) {
      tire.supplier = {
        supplierId: this.tire.vendor._id,
        name: this.tire.vendor.name,
      };
    }

    if (size.pricingMatrix) {
      tire.pricing = {
        pricingId: size.pricingMatrix._id,
        name: size.pricingMatrix.name,
      };
    }

    if (this.isNewItemCategoriesEnable) {
      if (this.tire.category?.categoryId) {
        tire.category = {
          categoryId: this.tire.category.categoryId,
          categoryName: this.tire.category.categoryName,
          _id: this.tire.category?._id,
        };
      }
    }

    if (this.isNewItemCategoriesEnable && this.isSalesCodeEnabled) {
      tire.isAutoAssign = this.isAutoAssign;
    }

    if (this.tireId) {
      this.handleUpdateTire(tire);
    } else {
      this.handleCreateTire(tire);
    }
  }

  handleUpdateTire(tire: any) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    delete tire.storageRO;
    const item = this.helperService.deepCopy(tire);
    if (this.isSalesCodeEnabled && !this.canEditClassifications && this.orderServiceId) {
      tire.salesCode = this.defaultSalesCode;
    }

    this.httpService.updateItem({ ...tire, _id: this.tireId }).then(
      (res: any) => {
        delete tire.tireStorageStatus;
        this.handleCloseModal();
        this.dataService.sendData(this.dataService.typePassData('tire-list', {}));
        this.helperService.showToaster('success', 'Tire storage updated');
        this.isProcessing = false;

        if (this.isSalesCodeEnabled && !this.canEditClassifications && this.orderServiceId) {
          res.salesCode = item?.salesCode;
        }

        if (this.isSalesCodeEnabled) {
          this.logPXGaingSightCustomEvent(res);
        }

        if (this.orderServiceId) {
          this.dataService.sendData(
            this.dataService.typePassData('ro-service-item', {
              ...res,
              actionType: 'update',
              serviceId: this.orderServiceId,
              index: this.orderServiceItemIndex,
            })
          );
        }
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  logPXGaingSightCustomEvent(res: any) {
    if (res?.salesCode?.salesCodeId && res?.salesCode?.salesCodeId !== this.defaultSalesCode?.salesCodeId) {
      const logInfo = {
        itemName: res?.title || res?.name,
        salesCodeName: res?.salesCode?.title,
        salesCode: res?.salesCode?.shortName,
        category: res?.category?.name,
        subCategory: res?.category?.subCategoryName,
        itemType: res?.type,
        assignmentType: this.isAutoAssign ? 'Auto' : 'User has assigned sales code directly from the Catalog/RO',
      };
      this.helperService.logPXGaingSightEvent('Sales code assigned to an item', logInfo);
    }
  }

  handleCreateTire(tire: any) {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;
    const item = this.helperService.deepCopy(tire);
    if (this.isSalesCodeEnabled && !this.canEditClassifications && this.orderServiceId) {
      tire.salesCode = this.defaultSalesCode;
    }
    this.httpService.createTireStorage(tire).then(
      (tire) => {
        this.handleCloseModal();
        this.dataService.sendData(this.dataService.typePassData('tire-list', {}));
        this.helperService.showToaster('success', 'Tire created');

        if (this.isSalesCodeEnabled && !this.canEditClassifications && this.orderServiceId) {
          tire.salesCode = item?.salesCode;
        }

        if (this.isSalesCodeEnabled) {
          this.logPXGaingSightCustomEvent(tire);
        }

        if (this.orderServiceId) {
          this.dataService.sendData(
            this.dataService.typePassData('ro-service-item', {
              ...tire,
              actionType: 'create',
              serviceId: this.orderServiceId,
              index: this.orderServiceItemIndex,
            })
          );
        }

        this.isProcessing = false;
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  onUpdateSupplier(data) {
    this.httpService.updateSupplier(data).then(
      (res: any) => {
        for (let i = 0; i < this.suppliers.length; i++) {
          if (this.suppliers[i]._id === res._id) {
            this.suppliers[i].name = data.name;
            break;
          }
        }

        for (let i = 0; i < this.vendorsSuggestion.length; i++) {
          if (this.vendorsSuggestion[i]._id === res._id) {
            this.vendorsSuggestion[i].name = data.name;
            break;
          }
        }

        if (this.tire.vendor && this.tire.vendor._id === res._id) {
          this.tire.vendor.name = data.name;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  onUpdateItem({ name, color, _id }, type: string) {
    const tag = {
      _id,
      color: color,
      type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        const tempCategories: any[] = this.helperService.deepCopy(this.categories);
        this.categories = [];
        for (let i = 0; i < tempCategories.length; i++) {
          if (tempCategories[i]._id === _id) {
            tempCategories[i].name = name;
            break;
          }
        }
        this.categories = tempCategories;

        for (let i = 0; i < this.tagsSuggestion.length; i++) {
          if (this.tagsSuggestion[i]._id === _id) {
            this.tagsSuggestion[i].name = name;
            break;
          }
        }

        if (this.tire.brand && this.tire.brand._id === _id) {
          this.tire.brand.name = name;
        }
        this.cdr.detectChanges();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleCreateBrand(data: any) {
    data.type = config.tags.tire;

    if (!data.isForFurtureUse) {
      this.categories.push(data);
      this.tagsSuggestion.push(data);
    } else {
      this.httpService.createTag(data).then(
        (category: any) => {
          if (category) {
            const tempCategories: any[] = this.helperService.deepCopy(this.categories);
            this.categories = [];
            tempCategories.push(category);
            this.helperService.showToaster('success', 'Brand created');
            this.categories = tempCategories;
            this.tagsSuggestion.push(category);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  handleCreateSupplier(data: any) {
    if (!data.isForFurtureUse) {
      this.suppliers.push(data);
      this.vendorsSuggestion.push(data);
    } else {
      this.httpService.createSupplier(data).then(
        (supplier: any) => {
          if (supplier) {
            this.helperService.showToaster('success', 'Vendor created');
            this.suppliers.push(supplier);
            this.vendorsSuggestion.push(supplier);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err.messages);
        }
      );
    }
  }

  updateLocations(locations: any[]) {
    this.locations = [...locations];
  }

  categoryDropdownSelect(type: string, event: any) {
    const payload: any = { salesCode: event.salesCode };

    if (type === 'category' && event.categoryId) {
      delete this.tire?.category?.subCategoryId;
      delete this.tire?.category?.subCategoryName;
      delete this.tire?.category?.subSubCategoryId;
      delete this.tire?.category?.subSubCategoryName;
      this.getSubCategories(event);
      this.subCategoriesSuggestions = [];
      this.subCategoriesSuggestionsResults = [];
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = event;
    }

    if (type === 'subCategory' && event.subCategoryId) {
      delete this.tire?.category?.subSubCategoryId;
      delete this.tire?.category?.subSubCategoryName;
      this.getSubSubCategories(this.tire?.category, event);
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = {
        categoryId: this.tire.category.categoryId,
        categoryName: this.tire.category.categoryName,
      };
      payload.subCategory = event;
    }

    if (type === 'subSubCategory' && event?.subSubCategoryId) {
      payload.category = {
        categoryId: this.tire.category.categoryId,
        categoryName: this.tire.category.categoryName,
      };
      payload.subCategory = {
        subCategoryId: this.tire.category.subCategoryId,
        subCategoryName: this.tire.category.subCategoryName,
      };
      payload.subSubCategory = event;
    }

    this.onSelectCategory(payload);
  }

  onSelectCategory(event: any) {
    const { category, salesCode, isAutoAssign } = this.helperService.onCategorySelect(event, this.tire.salesCode?.salesCodeId);

    this.tire.category = category;
    this.tire.salesCode = salesCode;

    this.subCategoriesSuggestions = [];
    this.subCategoriesSuggestionsResults = [];
    this.subSubCategoriesSuggestions = [];
    this.subSubCategoriesSuggestionsResults = [];
  }

  getAllCategories() {
    const query: any = { itemType: 'tireStorage' };
    this.loader.category = true;
    // if (this.query) query.searchTerm = encodeURI(this.query);
    this.httpService
      .getPricingCategories(query)
      .then((res: any) => {
        this.categoriesSuggestions = res.categories;
        this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
        if (this.categoriesSuggestionsResults?.length) {
          const category = this.categoriesSuggestionsResults[0];
          this.defaultTireCategory = {
            _id: category._id,
            name: category.categoryName,
            categoryId: category.categoryId,
            categoryName: category.categoryName,
            salesCode: category.salesCode,
          };
          this.tire.category = category;
          this.tire.salesCode = category?.salesCode;
          if (this.tire?.salesCode?.salesCodeId) {
            this.isAutoAssign = true;
          }
        }
      })
      .finally(() => {
        this.loader.category = false;
      });
  }

  getSubCategories(item) {
    this.loader.subCategory = true;
    this.httpService
      .getPricingSubCategories(item.categoryId, 'tireStorage')
      .then((res: any) => {
        if (res && res.subCategories?.length) {
          this.subCategoriesSuggestions = res.subCategories;
          this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
        } else {
          this.subCategoriesSuggestions = [];
          this.subCategoriesSuggestionsResults = [];
        }
      })
      .finally(() => {
        this.loader.subCategory = false;
      });
  }

  getSubSubCategories(item, level2) {
    this.loader.subSubCategory = true;
    this.httpService
      .getPricingSubSubCategories(item.categoryId, level2.subCategoryId, 'tireStorage')
      .then((res: any = {}) => {
        if (res && res.subSubCategories?.length) {
          this.subSubCategoriesSuggestions = res.subSubCategories;
          this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestions);
        } else {
          this.subSubCategoriesSuggestions = [];
          this.subSubCategoriesSuggestionsResults = [];
        }
      })
      .finally(() => {
        this.loader.subSubCategory = false;
      });
  }
}
